/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Experience_Consistent_For_QuestionInputs */

const en_us2_onboarding_experience_consistent_for_question = /** @type {(inputs: Onboarding_Experience_Consistent_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For how long have you been training consistently?`)
};

const pt_br2_onboarding_experience_consistent_for_question = /** @type {(inputs: Onboarding_Experience_Consistent_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há quanto tempo você treina sem parar?`)
};

const es_419_onboarding_experience_consistent_for_question = /** @type {(inputs: Onboarding_Experience_Consistent_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Hace cuánto entrenas sin parar?`)
};

const pt_pt2_onboarding_experience_consistent_for_question = /** @type {(inputs: Onboarding_Experience_Consistent_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há quanto tempo treinas sem parar?`)
};

const fr_fr2_onboarding_experience_consistent_for_question = /** @type {(inputs: Onboarding_Experience_Consistent_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depuis combien de temps t'entraînes-tu sans interruption ?`)
};

const de_de2_onboarding_experience_consistent_for_question = /** @type {(inputs: Onboarding_Experience_Consistent_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange trainierst du schon regelmäßig?`)
};

const it_it2_onboarding_experience_consistent_for_question = /** @type {(inputs: Onboarding_Experience_Consistent_For_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da quanto tempo ti alleni con costanza?`)
};

/**
* | output |
* | --- |
* | "For how long have you been training consistently?" |
*
* @param {Onboarding_Experience_Consistent_For_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_experience_consistent_for_question = /** @type {((inputs?: Onboarding_Experience_Consistent_For_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Experience_Consistent_For_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_experience_consistent_for_question(inputs)
	if (locale === "es-419") return es_419_onboarding_experience_consistent_for_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_experience_consistent_for_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_experience_consistent_for_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_experience_consistent_for_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_experience_consistent_for_question(inputs)
	return en_us2_onboarding_experience_consistent_for_question(inputs)
});
export { onboarding_experience_consistent_for_question as "onboarding.experience_consistent_for.question" }